import { serializable, alias, object, list, primitive } from "serializr";
import { ExamChapterResult, StudentChapterResult } from "./chapter.model";
import { StudentExamResult } from "./class.model";
import { ClassroomModel } from "../CourseModels/ClassroomModel/classroom.model";
import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";


// export class StudentSubjectResult {
//   @serializable(alias("id", primitive()))
//   id?: number;

//   @serializable(alias("score", primitive()))
//   score?: number;

//   @serializable(alias("accuracy", primitive()))
//   accuracy?: number;

//   @serializable(alias("average_time_per_question", primitive()))
//   averageTimePerQuestion?: number;

//   @serializable(alias("exercise_attempt_duration", primitive()))
//   exerciseAttemptDuration?: number;

//   @serializable(alias("number_of_exercise_attempts", primitive()))
//   numberOfExerciseAttempts?: number;

//   @serializable(alias("subject_name", primitive()))
//   subjectName?: string;

//   @serializable(alias("subject_id", primitive()))
//   subjectId?: number;

//   @serializable(
//     alias("student_chapter_results", list(object(StudentChapterResult)))
//   )
//   studentChapterResults?: StudentChapterResult[] = [];

//   @serializable(alias("total_content_count", primitive()))
//   totalContentCount?: number;

//   @serializable(alias("student_content_count", primitive()))
//   completedContentCount?: number;

//   @serializable(alias("total_exercise_count", primitive()))
//   totalExerciseCount?: number;

//   @serializable(alias("attempted_exercise_count", primitive()))
//   completedExerciseCount?: number;
// }


export class StudentSubjectResult {
  @serializable(alias('subjectId', primitive()))
  id?: number;

  @serializable(alias("subjectId", primitive()))
  subjectId?: number;

  @serializable(alias('subjectName', primitive()))
  name?: string;

  @serializable(alias('chapterCount', primitive()))
  chapterCount?: number;

  @serializable(alias('completedPerc', primitive()))
  cummulativeCompletionPercentage?: number;

  @serializable(alias("accuracy", primitive()))
  accuracy?: number;

  @serializable(alias("totalContent", primitive()))
  totalContentCount?: number;

  @serializable(alias("contentDone", primitive()))
  completedContentCount?: number;

  @serializable(alias("contentCompleted", primitive()))
  contentCompletionPercentage?: number;

  @serializable(alias("duration", primitive()))
  exerciseAttemptDuration?: number;

  @serializable(alias("totalExcercise", primitive()))
  totalExerciseCount?: number;

  @serializable(alias("excerciseDone", primitive()))
  completedExerciseCount?: number;

  @serializable(alias("excerciseDone", primitive()))
  numberOfExerciseAttempts?: number;

  @serializable(alias("excerciseCompleted", primitive()))
  exerciseCompletionPercentage?: number;

  @serializable(alias("score", primitive()))
  score?: number;

  @serializable(alias("speed", primitive()))
  averageTimePerQuestion?: number;

  @serializable(alias("chapterData", list(object(StudentChapterResult))))
  studentChapterResults?: StudentChapterResult[] = [];
}

export class SubjectModel {
  @serializable(alias('id', primitive()))
  id?: number;
  @serializable(alias('subject_name', primitive()))
  name?: string;
  @serializable(alias('amount_paise', primitive()))
  amountPaise?: string;
  @serializable(alias('amount_rupees', primitive()))
  amountRupees?: string;
  @serializable(alias('amount', primitive()))
  amount?: number;
  @serializable(alias('is_active', primitive()))
  isActive?: boolean;
  @serializable(alias('class_room', object(ClassroomModel)))
  classRoom?: ClassroomModel;
 
  @serializable(alias('chaptor_count', primitive()))
  chapterCount?: number;
  @serializable(alias('exam_chapter_count', primitive()))
  examChapterCount?: number;
  @serializable(alias('cummulative_completion_percentage', primitive()))
  cummulativeCompletionPercentage?: number;
  @serializable(alias('exam_completion_percentage', primitive()))
  examExerciseCompletionPercentage?: number;
  @serializable(alias('exam_content_completion_percentage', primitive()))
  examContentCompletionPercentage?: number;
  @serializable(alias('exercise_completion_percentage', primitive()))
  exerciseCompletionPercentage?: number;
  @serializable(alias('content_completion_percentage', primitive()))
  contentCompletionPercentage?: number;
  @serializable(alias('display', primitive()))
  display?: string;
}
export class ClassRoomSubjectModel {
  @serializable(alias("id", primitive()))
  id?: string;
  @serializable(alias("subject_name", primitive()))
  name?: string;
  @serializable(alias("amount_paise", primitive()))
  amountPaise?: string;
  @serializable(alias("amount_rupees", primitive()))
  amountRupees?: string;
  @serializable(alias("amount", primitive()))
  amount?: number;
  @serializable(alias("is_active", primitive()))
  isActive?: boolean;
  @serializable(alias("chaptor_count", primitive()))
  chapterCount?: boolean;
  @serializable(alias("class_room", object(ClassroomModel)))
  classRoom?: string;
  @serializable(alias("subject_stream", object(MetaModel)))
  subjectStream?: string;
  @serializable(alias("subject_stream_id", primitive()))
  subjectStreamId?: string;
  @serializable(alias("subject", object(SubjectModel)))
  subject?: SubjectModel;
}




export class ExamSubjectResult {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("score", primitive()))
  score?: number;

  @serializable(alias("accuracy", primitive()))
  accuracy?: number;

  @serializable(alias("average_time_per_question", primitive()))
  averageTimePerQuestion?: number;

  @serializable(alias("duration", primitive()))
  exerciseAttemptDuration?: number;

  @serializable(alias("number_of_attempts", primitive()))
  numberOfExerciseAttempts?: number;

  @serializable(alias("exam_subject_name", primitive()))
  subjectName?: string;

  @serializable(alias("exam_subject_id", primitive()))
  subjectId?: number;

  @serializable(alias("exam_chapter_results", list(object(ExamChapterResult))))
  examChapterResults?: ExamChapterResult[] = [];

  @serializable(alias("exam_content_count", primitive()))
  totalContentCount?: number;

  @serializable(alias("student_exam_content_count", primitive()))
  completedContentCount?: number;

  @serializable(alias("total_exam_exercise_count", primitive()))
  totalExerciseCount?: number;

  @serializable(alias("attempted_exam_exercise_count", primitive()))
  completedExerciseCount?: number;
}
